import React from 'react';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Span, P, Margin } from '@helpers';

export const ColoredFonts = ({t}) => {
    return (
      <PageWrapper>
        <Container paddingTop='87px' marginLeft='102px' marginRight='42px' paddingBottom='94px'>
          <P weight='400' size='25px' height='30px'>{t("Using colored fonts")}</P>
          <FlexDiv>
            <Text width='362px' marginTop='7px' paddingBefforeText="45px" paddingAffterText='19px' paddingUl='19px'>
              <p>
                {t("The main gradient can be used as an additional text color in the following instances:")}
              </p>
              <ul>
                <li>
                  {t("- to highlight the clickable text hovering;")}
                </li>
                <li>
                  {t("- to highlight text links;")}
                </li>
                <li>
                  {t("- to highlight headlines or simple text (frequent use is not recommended).")}
                </li>
              </ul>
              <Span>
                {t("In the content about products, the additional text color can be used under the same conditions, provided that it matches the branded color of the product.")}
              </Span>
            </Text>
            <div>
              <Margin marginTop='67px' marginLeft='65px'>
                <P marginTop='134px' size='15px' weight='400' height='30px' gradient={true}>
                  {t("To highlight the clickable text hovering")}
                </P>
                <P marginTop='37px' size='15px' weight='400' height='30px' gradient={true} decoration='underline'>
                  {t("To highlight text links")}
                </P>
                <P marginTop='38px' size='16px' weight='700' height='32px' gradient={true}>
                  {t("To highlight headlines or simple text (frequent use is not recommended).")}
                </P>
              </Margin>
            </div>
          </FlexDiv>
        </Container>
    </PageWrapper>
  );
};
